import '@/styles/index.css'
import '@nexans/react-ui-kit/styles.css'
import 'azure-maps-control/dist/atlas.min.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import { BrowserRouter } from 'react-router-dom'

import { i18next } from '@/lib/react-i18next'
import { preloadIcons } from '@/lib/react-iconify.ts'

import App from './App.tsx'
import { loadAppInsights } from './appInsights.ts'

preloadIcons()
loadAppInsights()

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </BrowserRouter>
  </React.StrictMode>
)
